import { Component, Input } from '@angular/core'

@Component({
  selector: 'truncated-list',
  templateUrl: './truncated-list.component.html',
  styleUrls: ['./truncated-list.component.scss'],
  standalone: false,
})
export class TruncatedListComponent {
  @Input() items: string[]
  @Input() maxVisible: number = 10

  get visibleText(): string {
    const visibleItems = this.items.slice(0, this.maxVisible)
    return visibleItems.join(', ')
  }

  get hasMore(): boolean {
    return this.items.length > this.maxVisible
  }

  get moreLabel(): string {
    const moreItems = this.items.slice(this.maxVisible)
    return `+ ${moreItems.length} more`
  }

  get moreText(): string {
    const moreItems = this.items.slice(this.maxVisible)
    return moreItems.join('\n')
  }
}
